import { getUrlParams, commonParseQuery, parseJson } from "./common-utils";

const parseHomePageUrlToConfig = (url) => {
  const searchParams = getUrlParams(url);
  const { qryParams = '{}' } = searchParams;
  const parsedJson = parseJson(qryParams);
  const { s_n, s_i, d_n, d_i, s_t, e_t, t_t = "ONE_WAY", rf = "ow", s_c = "", off = 0, r_off = 0, pc = "", flow = "" } = parsedJson;
  const { newSDate, newSTime, newEDate, newETime } = commonParseQuery({ s_t, e_t, off, r_off, isHomePage: flow !== "Flights_Mytrips_Details_Page" });
  const parseData = {
    startDate: {
      date: newSDate,
      time: Array.isArray(newSTime) && newSTime?.length > 1 ? newSTime[0] : newSTime
    },
    endDate: {
      date: newEDate,
      time: Array.isArray(newETime) && newETime?.length > 1 ? newETime[0] : newETime
    },
    source: {
      name: s_n,
      place_id: s_i,
      city_name: s_c
    },
    destination: {
      name: d_n,
      place_id: d_i
    },
    tripType: {
      name:  e_t || r_off ? 'ROUND_TRIP' : t_t,
      rf:  e_t || r_off ? 'rt' : rf
    },
    flow,
    pc,
    isSeo: !!(s_n && s_i && d_i && d_n && t_t)
  }
  return parseData;
};

export default parseHomePageUrlToConfig;